import { keys } from 'dibs-ts-utils/exports/keys.ts';

import { type SupportChatType, type SupportChatTouchpoint } from './types.ts';

const SUPPORT_CHAT_BUTTON_ID = 'support-chat-button';

const CSS_VARIABLES = {
    ANIMATION_DURATION_MS: 400,
    TIMING_FUNCTION: 'cubic-bezier(0.68, -0.01, 0.35, 1.02)',
} as const;

const SUPPORT_CHAT_TYPE_MAP: Record<SupportChatType, SupportChatType> = {
    SALESFORCE: 'SALESFORCE',
    SIERRA: 'SIERRA',
};

const SUPPORT_CHAT_TYPES = keys(SUPPORT_CHAT_TYPE_MAP);

const SUPPORT_CHAT_TOUCHPOINTS: SupportChatTouchpoint[] = [
    'Buyer_Messaging',
    'Guest_Buyer_Messaging',
    'Seller_Messaging',
];

const SELLER_SUPPORT_CHAT_TOUCHPOINTS: SupportChatTouchpoint[] = ['Seller_Messaging'];

const DISABLE_AUTH_SUPPORT_CHAT_TOUCHPOINTS: SupportChatTouchpoint[] = ['Guest_Buyer_Messaging'];

const PRE_CHAT_FIELD_MAP = {
    dibsSellerId: 'dibsSellerId',
    dibsUserId: 'dibsUserId',
    itemId: 'itemId',
    messageInitiator: 'messageInitiator',
    orderId: 'orderId',
    pageType: 'pageType',
    topic: 'topic',
    touchpoint: 'touchpoint',
} as const;

export {
    SUPPORT_CHAT_BUTTON_ID,
    CSS_VARIABLES,
    SUPPORT_CHAT_TYPES,
    SUPPORT_CHAT_TOUCHPOINTS,
    SELLER_SUPPORT_CHAT_TOUCHPOINTS,
    DISABLE_AUTH_SUPPORT_CHAT_TOUCHPOINTS,
    PRE_CHAT_FIELD_MAP,
};
